/**
 * Color utility functions for the neon aesthetic.
 */

import { GAME_CONFIG } from '../config/gameConfig';
import { AlienType } from '../entities/Alien';

/**
 * Get the neon color for an alien type.
 */
export function getAlienColor(type: AlienType): number {
  switch (type) {
    case 'top':
      return GAME_CONFIG.colors.alienTop;
    case 'middle':
      return GAME_CONFIG.colors.alienMiddle;
    case 'bottom':
      return GAME_CONFIG.colors.alienBottom;
  }
}

/**
 * Convert a hex number to CSS color string.
 */
export function hexToString(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}

/**
 * Create a glow-style shadow for text.
 */
export function neonTextStyle(
  color: string = '#00ffff',
  fontSize: string = '16px'
): Phaser.Types.GameObjects.Text.TextStyle {
  return {
    fontSize,
    color,
    fontFamily: '"Press Start 2P", monospace',
    shadow: {
      offsetX: 0,
      offsetY: 0,
      color: color,
      blur: 8,
      stroke: true,
      fill: true,
    },
  };
}
